import { ModelMeta, ReportMeta, EfeReportMeta } from './reports.actions';

export const reportsInitialState: {
  modelsMeta: Record<string, Record<string, ModelMeta>>;
  reportsMeta: Record<string, Record<string, ReportMeta>>;
  efeReportsMeta: Record<string, Record<string, EfeReportMeta>>;
} = {
  modelsMeta: {
    entity: {},
    group: {}
  },
  reportsMeta: {
    entity: {},
    group: {}
  },
  efeReportsMeta: {
    entity: {},
    group: {}
  }
};
